import { Controller, UseFormHandleSubmit, UseFormSetValue, UseFormRegister, Control, UseFormGetValues, FieldErrorsImpl } from "react-hook-form";
import { FormatDateIso } from "utils/dateUtils";
import { toast } from "react-toastify";
import { useAppDispatch } from "hooks/hooks";
import { styles } from "../../../../../../components/Popover/popoverSelectStyle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import classes from "../../../../../../components/Popover/popover.module.scss";
import classesCB from "Dashboard/scenes/ConcreteBase/styles/popover.module.scss";
import PartnerSimpleSelect from "Dashboard/scenes/Partners/components/PartnerSimpleSelect";
import DriverSelectCreate from "Dashboard/scenes/Stock/secenes/Input/components/DriverSelectCreate";
import { concreteBaseService } from "Dashboard/scenes/ConcreteBase/services/concreteBase.service";
import { IConcreteBaseInputCreate } from "Dashboard/scenes/ConcreteBase/domain/IConcreteBaseInputCreate";
import ConcreteBaseItemSelectCreate from "./ConcreteBaseItemSelectCreate";
import RepositorySelect from "./RepositorySelect";
import DatePicker from "react-datepicker";
import { addNewInput, setNewInputPopover } from "../inputSlice";
import UnitSelect from "Dashboard/components/UnitSelect";
import NumberInput from "Dashboard/components/NumberInput";
import ItemCodeSelect from "Dashboard/components/ItemCodeSelect";
import { IOption } from "Dashboard/domain/IOption";
import { hasFullAccessTo } from "utils/authUtil";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { CONCRETE_BASE_MODULE_NAME } from "Dashboard/scenes/ConcreteBase/domain/ConcreteBaseModule";
import { useSelector } from "react-redux";
import { useState } from "react";

interface IProps {
  handleSubmit: UseFormHandleSubmit<IConcreteBaseInputCreate>;
  setValue: UseFormSetValue<IConcreteBaseInputCreate>;
  register: UseFormRegister<IConcreteBaseInputCreate>;
  control: Control<IConcreteBaseInputCreate, any>;
  getValues: UseFormGetValues<IConcreteBaseInputCreate>;
  errors: Partial<FieldErrorsImpl<IConcreteBaseInputCreate>>;
  reset: () => void;
  knownItemCodes: string[];
  setKnownItemCodes: React.Dispatch<React.SetStateAction<string[]>>;
  supplierValue: IOption | undefined;
  setSupplierValue: React.Dispatch<React.SetStateAction<IOption | undefined>>;
  driverValue: IOption | undefined;
  setDriverValue: React.Dispatch<React.SetStateAction<IOption | undefined>>;
}

const NewInputPopover = (props: IProps) => {
  const dispatch = useAppDispatch();

  const {
    handleSubmit,
    setValue,
    register,
    control,
    getValues,
    errors,
    reset,
    knownItemCodes,
    setKnownItemCodes,
  } = props;
  const { user } = useSelector(selectStateAuth);
  const [isOwnProduct, setIsOwnProduct] = useState<boolean | null>(hasFullAccessTo(user, CONCRETE_BASE_MODULE_NAME) ? null : false);

  const onSubmit = async (data: IConcreteBaseInputCreate) => {
    try {
      const response = await concreteBaseService.createConcreteBaseInput(data);
      close();
      toast.success("Ulaz je uspešno dodat!");
      dispatch(addNewInput(response));
    } catch (err: any) {
      if (err.response.status === 400) {
        toast.error("Proverite da li ste uneli sve podatke");
      }
    }
  };

  const close = () => {
    dispatch(setNewInputPopover({ isOpen: false }));
    reset();
    props.setSupplierValue(undefined);
    props.setDriverValue(undefined);
  };

  const numberToString = (n: number) => {
    if (n === undefined || n === null) {
      return undefined;
    }
    return n.toString().replace(".", ",");
  }

  const onChangeRepositoryShortName = (shortName: string) => {
    if (shortName === 'RMbb') {
      setIsOwnProduct(false);
    } else if (shortName === 'BGbb') {
      setIsOwnProduct(true);
    } else {
      setIsOwnProduct(null);
    }
  }

  return (
    <form
      className={`${classesCB.newInputPopover} ${classes.basicPopover}`}
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className={`${classes.row} ${classes.rowDir}`}>
        <div className={`${classes.col} ${classes.colDir} ${classesCB.cbItemWidth}
          ${errors.itemId ? classes.itemError : ""}`}>
          <label className={classes.aboveLabel}>naziv</label>
          <Controller
            name="itemId"
            control={control}
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange } }) => (
              <ConcreteBaseItemSelectCreate
                value={getValues("itemId")}
                setValue={setValue}
                isOwnProduct={isOwnProduct}
                setKnownItemCodes={setKnownItemCodes}
                error={errors.itemId}
                customStyles={styles.customStyleClassic}
                onChange={onChange}
                preserveInput={true}
              />
            )}
          />
        </div>

        <div className={`${classes.col} ${classes.colDir} ${classesCB.cbItemWidth}
          ${errors.repositoryId ? classes.itemError : ""}`}>
          <label className={classes.aboveLabel}>magacin</label>
          <Controller
            name="repositoryId"
            control={control}
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange } }) => (
              hasFullAccessTo(user, CONCRETE_BASE_MODULE_NAME)
                ? <RepositorySelect
                  error={errors.repositoryId}
                  customStyles={styles.customStyleClassic}
                  onChange={onChange}
                  allowedRepositories={["RMbb", "BGbb"]}
                  onChangeShortName={onChangeRepositoryShortName}
                />
                : <RepositorySelect
                  error={errors.repositoryId}
                  customStyles={styles.customStyleClassic}
                  onChange={onChange}
                  fixedRepository={"RMbb"}
                />
            )}
          />
        </div>

        <div className={`${classes.col} ${classes.colDir} ${classesCB.cbItemWidth}
          ${errors.supplierPartnerId ? classes.itemError : ""}`}>
          <label className={classes.aboveLabel}>dobavljač</label>
          <Controller
            name="supplierPartnerId"
            control={control}
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange } }) => (
              <PartnerSimpleSelect
                value={props.supplierValue}
                setValue={props.setSupplierValue}
                error={errors.supplierPartnerId}
                customStyles={styles.customStyleClassic}
                onChange={onChange}
              />
            )}
          />
        </div>
      </div>

      <div className={`${classes.row} ${classes.rowDir}`}>
        <div className={`${classes.col} ${classes.colDir} ${classesCB.cbItemWidth}
          ${errors.broughtByDriverId ? classes.itemError : ""}`}>
          <label className={classes.aboveLabel}>prevoznik</label>
          <Controller
            name="broughtByDriverId"
            control={control}
            defaultValue={undefined}
            rules={{
              required: false,
            }}
            render={({ field: { onChange } }) => (
              <DriverSelectCreate
                value={props.driverValue}
                setValue={props.setDriverValue}
                customStyles={styles.customStyleClassic}
                error={errors.broughtByDriverId}
                onChange={onChange}
                preserveInput={true}
              />
            )}
          />
        </div>

        <div className={`${classes.col} ${classes.colDir}`}>
          <label className={classes.aboveLabel}>br. otpremnice</label>
          <input type="text" className={`${classes.itemBorder} ${classesCB.cbItemWidth}
            ${errors.billOfLandingId ? classes.itemError : ""}`}
            {...register("billOfLandingId", { required: true })}
          />
        </div>

        <div className={`${classes.col} ${classes.colDir} ${classesCB.code}`}>
          <label className={classes.aboveLabel}>šifra artikla</label>
          <Controller
            name="itemCode"
            control={control}
            defaultValue={undefined}
            rules={{
              required: false,
            }}
            render={({ field: { onChange } }) => (
              <ItemCodeSelect
                value={getValues("itemCode")}
                knownItemCodes={knownItemCodes}
                customStyles={styles.customStyleClassic}
                error={errors.itemCode}
                onChange={onChange}
              />
            )}
          />
        </div>
      </div>

      <div className={`${classes.row} ${classes.rowDir}`}>
        <div className={`${classes.col} ${classes.colDir} ${classesCB.qnt}`}>
          <label className={classes.aboveLabel}>količina</label>
          <Controller
            name="quantityAmount"
            control={control}
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange } }) => (
              <NumberInput
                formatAs="quantity"
                value={numberToString(getValues("quantityAmount"))}
                onChange={(value: string, unmaskedValue: string, parsedValue: number) => onChange({ target: { value: unmaskedValue } })}
                className={`${classes.itemBorder} ${classesCB.qnt}
              ${errors.quantityAmount ? classes.itemError : ""}`}
              />
            )}
          />
        </div>
        <div className={`${classes.col} ${classes.colDir} ${classesCB.qntU}
          ${errors.quantityUnit ? classes.itemError : ""}`}>
          <label className={classes.aboveLabel}>mera</label>
          <Controller
            name="quantityUnit"
            control={control}
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange } }) => (
              <UnitSelect
                value={getValues("quantityUnit")}
                customStyles={styles.customStyleClassic}
                error={errors.quantityUnit}
                onChange={onChange}
                isClearable={false}
              ></UnitSelect>
            )}
          />
        </div>

        <div className={`${classes.col} ${classes.colDir}`}>
          <label className={classes.aboveLabel}>cena</label>
          <Controller
            name="pricePerUnit"
            control={control}
            defaultValue={undefined}
            rules={{
              required: false,
            }}
            render={({ field: { onChange } }) => (
              <NumberInput
                formatAs="rsd"
                value={numberToString(getValues("pricePerUnit"))}
                onChange={(value: string, unmaskedValue: string, parsedValue: number) => onChange({ target: { value: unmaskedValue } })}
                className={`${classes.itemBorder} ${classesCB.cbItemWidth}
              ${errors.pricePerUnit ? classes.itemError : ""}`}
              />
            )}
          />
        </div>

        <div className={`${classes.col} ${classes.colDir} ${classesCB.deliveryPrice}`}>
          <label className={classes.aboveLabel}>cena isporuke</label>
          <Controller
            name="deliveryPrice"
            control={control}
            defaultValue={undefined}
            rules={{
              required: false,
            }}
            render={({ field: { onChange } }) => (
              <NumberInput
                formatAs="rsd"
                value={numberToString(getValues("deliveryPrice"))}
                onChange={(value: string, unmaskedValue: string, parsedValue: number) => onChange({ target: { value: unmaskedValue } })}
                className={`${classes.itemBorder} ${classesCB.cbItemWidth}
              ${errors.deliveryPrice ? classes.itemError : ""}`}
              />
            )}
          />
        </div>
      </div>

      <div className={`${classes.row} ${classes.rowDir}`}>
        <div className={`${classes.col} ${classes.colDir}`}>
          <label className={classes.aboveLabel}>datum otpremnice</label>
          <Controller
            control={control}
            name="billOfLandingDate"
            defaultValue={FormatDateIso(new Date())}
            rules={{ required: true }}
            render={({ field: { onChange, value } }) => (
              <div>
                <DatePicker
                  onChange={(date) =>
                    onChange(date ? FormatDateIso(date) : undefined)
                  }
                  showMonthDropdown
                  showYearDropdown
                  dateFormat="dd.MM.yyyy"
                  selected={value ? new Date(value) : null}
                  className={`${classes.itemBorder} ${classes.dateItem} ${classesCB.cbItemWidth}
                    ${errors.billOfLandingDate ? classes.itemError : ""}`}
                />
              </div>
            )}
          />
        </div>
      </div>

      <div className={`${classes.row} ${classes.rowDir}`}>
        <div className={`${classes.col} ${classes.colDir}`}>
          <label className={classes.aboveLabel}>napomena</label>
          <input type="text" className={classes.itemBorder}
            {...register("note", { required: false })} />
        </div>

        <div className={`${classes.buttons} ${classes.bottom}`}>
          <button className={classes.iconButton} type="submit">
            <FontAwesomeIcon
              icon={faLongArrowAltDown}
              className={classes.icon} />
          </button>
        </div>
      </div>

    </form>
  );
};

export default NewInputPopover;
